export const IconAnimatedClasses = {
    ICON_NONE: [],
    ICON_PULSE: ['fa-pulse'],
    ICON_SPIN: ['fa-spin']
}
